export const palette = {
  primary: {
    light: '#FF8181',
    main: '#EE3124',
    dark: '#d31f12',
    contrastText: '#ffffff',
  },
  secondary: {
    light: '#9b9b9b',
    main: '#346094',
    dark: '#000000',
    contrastText: '#ffffff',
  },
  tertiary: {
    lgray: '#f3f3f3',
    mgray: '#E0E0E0',
    dblue: '#212844',
    gray: '#666',
  },
  success: {
    light: '#edf7ed',
    main: '#2e7d32',
    dark: '#1e4620',
    contrastText: '#ffffff',
  },
  error: {
    light: '#fdeded',
    main: '#EE3124',
    dark: '#5f2120',
    contrastText: '#ffffff',
  },
  warning: {
    light: '#fff4e5',
    main: '#ed6c02',
    dark: '#663c00',
    contrastText: '#011838',
  },
  info: {
    light: '#e5f6fd',
    main: '#0288d1',
    dark: '#014361',
    contrastText: '#ffffff',
  },
  gray: {
    light: '#EEEEEE',
    main: '#D2D2D2',
    dark: '#858585',
    contrastText: '#fff',
  },
  transparent: {
    red: 'rgba(238, 52, 35, 0.75)',
    black: 'rgba(0, 0, 0, 0.5)',
    white: 'rgb(255, 255, 255, .75)',
    total: 'rgba(0, 0, 0, 0)',
    contrastText: '#fff',
  },
};
